/* eslint-disable @next/next/no-img-element */
import { useEffect, useState, useContext } from "react";
import http from "utilities/http";
import Image from "next/image";
import { getCookie } from "framework/libs/cookie";
import { TOKEN_CONGDONG, TOKEN_CHAT } from "framework/store/constants";
import { isEmpty } from 'lodash';
import { MEMBERSHIP_IMAGE } from "utilities/constants";
import { displayWithK } from "utilities/helper";
import { toast } from 'react-toastify';
import ProfessionalComponent from 'components/chuyen-gia/newProfessionalComponent';
import { Button, Modal } from "react-bootstrap";
import ModalDanhGia from 'components/chuyen-gia/content/detail/modalDanhGia';
import { Loader } from "components/loader";
import SeeMore from "components/seeMore";
import { useCart } from "framework/store";
import Link from "next/link";
import { ChatContext } from "context/chatContext";
import { getUrlName } from 'utilities/helper';
import StarList from 'components/shop/review/starList';
import ButtonModalDonTuVan from "components/don-tu-van/buttonModalDonTuVan";
import { Tooltip } from "antd";
export default function Index({ proInf, profession }) {
    const { setIsChatHidden, setVendor } = useContext(ChatContext);
    const [stateStore, actions] = useCart();
    const vendorList = stateStore.vendorList;
    const per_page = 6;
    const [proInfG, setProInfG] = useState(proInf);
    const [currentFollow, setCurrentFollow] = useState(proInf?.is_followed);

    const fetchData = async () => {
        const token = !isEmpty(getCookie(TOKEN_CONGDONG)) ? 'Bearer ' + getCookie(TOKEN_CONGDONG) : 'default';

        const res = await http(`community/professional/${profession.id}`, {}, { token: token }, 'v2');
        if (res?.code == 200) {
            setProInfG(res?.data);
            setCurrentFollow(res?.data?.is_followed);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);


    const toggleFollow = async () => {
        if (isEmpty(getCookie(TOKEN_CONGDONG))) {
            toast.info('Bạn cần đăng nhập để thao tác.');
            return;
        }
        setCurrentFollow(() => (!currentFollow));
        // if (!currentFollow) toast.info(`Bạn đã theo dõi ${proInfG.display_name}`);
        // if (currentFollow) toast.info(`Bạn đã bỏ theo dõi ${proInfG.display_name}`);

        const res = await http(`community/professional/follows/toggle`, {}, {
            body: { id: proInfG?.id },
            method: 'POST',
            token: "Bearer " + getCookie(TOKEN_CONGDONG)
        }, 'v2');
    };

    const showroomJob = (!isEmpty(proInfG?.field) ? proInfG?.field?.name : '')
        + (!isEmpty(proInfG?.job_title && proInfG?.job_title?.name != 'Khác') ? (' -  ' + proInfG?.job_title?.name) : '');


    const [modalDanhGiaDisplay, setModalDanhGiaDisplay] = useState(false);
    const [state, _setState] = useState({
        modalFollowStatus: false,
        currentModal: "",
        followers: [],
        paginate_followers: {},
        total_followers: true,
        followings: [],
        paginate_followings: {},
        total_followings: true,
        loading: false
    });
    useEffect(() => { state.modalFollowStatus ? fetchDataFollow("1") : ""; }, [state.modalFollowStatus,]);
    const fetchDataFollow = async (page = 1) => {
        setState({ loading: true });
        const response = await http(`community/professional/${profession.id}/${state.currentModal}?page=${page}&per_page=${per_page}`, null, {
            token: "Bearer " + getCookie(TOKEN_CONGDONG)
        }, 'v2');
        if (response.code === 200) {
            setState({
                [state.currentModal]: page == 1 ? response.data : state[state.currentModal].concat(response.data),
                [`paginate_${state.currentModal}`]: response?.meta?.pagination?.current_page,
                [`total_${state.currentModal}`]: response?.meta?.pagination?.total
            });
        }
        setState({ loading: false });
    };
    const setState = (_state = {}) => {
        _setState((state) => ({
            ...state,
            ..._state
        }));
    };
    const seeFollow = (action) => {
        setState({
            modalFollowStatus: true,
            currentModal: action,
        });
    };
    const setCurrentPage = () => { fetchDataFollow(state[`paginate_${state.currentModal}`] + 1); };

    const followModal = () => {
        return (
            <Modal show={state.modalFollowStatus} onHide={() => { setState({ modalFollowStatus: false }); }} role="document" className="">
                <Modal.Header closeButton>
                    <h5 className="modal-title">{state.currentModal === "followers" ? "Theo dõi" : "Đang theo dõi"}</h5>
                </Modal.Header>
                <Modal.Body style={{ padding: "5px 20px" }}>
                    <div style={{ height: "74vh", overflowX: "auto" }}>
                        <ul className="expert__list">
                            {state[state.currentModal]?.length > 0 && state[state.currentModal].map(item =>
                                <li style={{ width: "50%" }} key={item?.id}><ProfessionalComponent item={item} parent="profile" /></li>
                            )}
                        </ul>
                    </div>
                    <SeeMore page={[per_page, state[`total_${state.currentModal}`]]} currentPage={state[`paginate_${state.currentModal}`]} setCurrentPage={setCurrentPage} />
                </Modal.Body>
            </Modal>
        );
    };

    const genMemberShip = (item) => {
        let classNameByLevel = 'btn--blueBold';
        let levelImage = MEMBERSHIP_IMAGE[0];
        let levelName = item?.name || "Chim non";

        if (item?.id == 2) {
            classNameByLevel = 'btn--red';
            levelImage = MEMBERSHIP_IMAGE[1];
        }

        if (item?.id == 3) {
            classNameByLevel = 'btn--yellow p-2';
            levelImage = MEMBERSHIP_IMAGE[2];
        }

        return (
            <>
                <button className={"btn level-items " + classNameByLevel}>
                    <img src={levelImage} alt=""></img>
                    {" " + levelName}
                </button>
            </>
        );
    };
    const genMyShop = () => {
        const shop = stateStore.vendorList?.find(k => k.id == proInf?.vendor_id) || {};
        if (shop?.vendor_id) {
            return <Link href={`/shop/profile/${shop?.id}/${getUrlName(shop?.vendor_id)}`} passHref={true}>
                <div className="btn-message pt-0 my-shop-tv-uy-tin">
                    <button className="btn btn--blue"><span><img src="../images/icon-home-white.svg" alt="" /></span>Shop của tôi
                    </button>
                </div>
            </Link>;
        }
    };

    const startChat = () => {
        if (isEmpty(getCookie(TOKEN_CHAT))) {
            toast.info('Bạn cần đăng nhập trước khi chat');
            return;
        };
        setVendor({ id: profession.id, name: proInfG?.display_name, vendor_logo_url: proInfG?.avatar, isPro: true });
        setIsChatHidden(false);
    };

    return (
        <div className="expert__wrap-overview">
            <Loader loading={state.loading} />
            {followModal()}
            <div className="position-relative">
                <div
                    className="logo-showroow wrap-next-image-not-crop"
                    style={{
                        width: 64,
                        height: 64,
                        paddingTop: 0,
                        position: 'relative',
                        background: 'none',
                        margin: '0 auto',
                    }}
                >
                    <Image
                        layout="fill"
                        src={proInfG?.avatar || '/images/icon-app.svg'}
                        alt=""
                    />
                </div>
                {proInfG?.is_professional && (
                    <Tooltip
                        placement="right"
                        title={
                            <>
                                <img src="/chuyen-gia/Pro.svg" /> thể hiện tài
                                khoản Chuyên gia trên Happynest
                            </>
                        }
                        color="#278FF7"
                        overlayInnerStyle={{
                            borderRadius: 16,
                            width: 180,
                            fontSize: 12,
                            padding: 12,
                            lineHeight: '20px',
                        }}
                    >
                        <img
                            src="/chuyen-gia/Pro.svg"
                            className="position-absolute"
                            style={{ bottom: -10, left: 'calc(50% - 10px)' }}
                        />
                    </Tooltip>
                )}
            </div>
            <div className="showroom-over mt-2">
                <div className="showroom-info">
                    <div className="showroom-name">
                        <span className="user-name">
                            {proInfG?.display_name || 'Chưa đặt tên'}
                        </span>
                        {!!proInfG?.is_verified && (
                            <Tooltip
                                placement="right"
                                title="Hồ sơ năng lực của Chuyên gia đã được Happynest xác thực"
                                color="#278FF7"
                                overlayInnerStyle={{
                                    borderRadius: 16,
                                    width: 144,
                                    fontSize: 12,
                                    textAlign: 'justify',
                                    padding: 12,
                                }}
                            >
                                <img
                                    src="/chuyen-gia/Verified.svg"
                                    alt=""
                                    style={{ width: 68 }}
                                    className="cursor-pointer"
                                />
                            </Tooltip>
                        )}
                    </div>
                    {proInf?.is_professional && (
                        <p className="showroom-job">{showroomJob}</p>
                    )}

                    {proInf?.is_professional && (
                        <p className="showroom-location">
                            <img src="/images/icon-maps.svg" alt="" />
                            {' ' +
                                (proInfG.location ||
                                    proInfG.address ||
                                    'Chưa xác định vị trí')}
                        </p>
                    )}
                </div>
            </div>
            <div className="follow-over">
                <ul className="follow-list">
                    <li
                        onClick={() => {
                            seeFollow('followers');
                        }}
                        style={{ cursor: 'pointer' }}
                    >
                        Theo dõi{' '}
                        <span className="font-weight-semibold">
                            {proInfG?.followers || 0}
                        </span>
                    </li>
                    <li
                        onClick={() => {
                            seeFollow('followings');
                        }}
                        style={{ cursor: 'pointer' }}
                    >
                        Đang theo dõi{' '}
                        <span className="font-weight-semibold">
                            {proInfG?.following || 0}
                        </span>
                    </li>
                </ul>
                <div className="showroom-level">
                    {genMemberShip(proInfG?.membership_level?.data)}
                    {proInf.is_professional && (
                        <div className="rate-star">
                            <StarList
                                number={proInfG.rating}
                                onClickFunc={(num) => setRating(num)}
                            />
                            <span className="number">
                                ({displayWithK(proInfG.total_rating) || 0})
                            </span>
                        </div>
                    )}
                </div>
                {proInf.is_professional &&
                    !isEmpty(proInfG.achievements?.data) && (
                    <ul className="list-overview">
                        {proInfG?.achievements?.data
                            .slice(0, 5)
                            .map((x, i) => {
                                return (
                                    <li key={i}>
                                        <Image
                                            width={32}
                                            height={32}
                                            src={
                                                x?.file?.storage_url ||
                                                    '/images/overview-items1.png'
                                            }
                                            alt=""
                                        />
                                    </li>
                                );
                            })}
                        {proInfG?.achievements?.data?.length > 5 && (
                            <li className="items-number">{`+${
                                proInfG?.achievements?.data?.length - 5
                            }`}</li>
                        )}
                    </ul>
                )}
            </div>
            <div className="button__wrap">
                {proInf.is_professional && (
                    <button
                        className="btn btn--blue btn-msg"
                        onClick={startChat}
                    >
                        Nhắn tin
                    </button>
                )}
                <ul
                    className={
                        'contact-button-group' +
                        (!proInf.is_professional && proInf.id == 18
                            ? ' w-100'
                            : '')
                    }
                >
                    {proInf.is_professional && (
                        <li>
                            <button
                                className="btn btn--blueWhite"
                                onClick={() => {
                                    if (isEmpty(getCookie(TOKEN_CONGDONG))) {
                                        toast.info(
                                            'Bạn cần đăng nhập để thao tác.',
                                        );
                                        return;
                                    }
                                    setModalDanhGiaDisplay(true);
                                }}
                            >
                                Đánh giá
                            </button>
                        </li>
                    )}
                    {(proInf.is_professional || proInf.id == 18) && (
                        <li>
                            <button
                                className="btn btn--blueWhite p-1"
                                onClick={() => toggleFollow()}
                            >
                                {currentFollow ? 'Đang theo dõi' : 'Theo dõi'}
                            </button>
                        </li>
                    )}
                    {!proInf.is_professional && proInf.id == 18 && (
                        <li>
                            <button
                                className="btn btn--blue"
                                onClick={startChat}
                            >
                                Nhắn tin
                            </button>
                        </li>
                    )}
                </ul>
            </div>
            {genMyShop()}
            {(proInfG.is_consulting || proInfG.id == 18) &&
                stateStore.consultantFilters.receive_advice && (
                <div className="w-100">
                    <p
                        className="font-size-16 font-weight-500 mt-4"
                        style={{ color: '#222' }}
                    >
                            Bạn muốn được tư vấn?
                    </p>
                    <p
                        className="font-size-13 mt-2"
                        style={{ color: '#666' }}
                    >
                            Hãy để chúng tôi tư vấn, hỗ trợ bạn trong việc xây
                            dựng tổ ấm của mình. Tạo yêu cầu của bạn ở đây nhé
                    </p>
                    <div className="mt-3">
                        <ButtonModalDonTuVan
                            chuyenGia={proInf}
                            source={proInf.id === 18 ? 7 : 6}
                        />
                    </div>
                </div>
            )}
            {proInf.is_professional && (
                <ModalDanhGia
                    modalDanhGiaDisplay={modalDanhGiaDisplay}
                    setModalDanhGiaDisplay={setModalDanhGiaDisplay}
                    professional={proInfG}
                />
            )}
        </div>
    );
}